import React from 'react'

import AddColumn, {AddColumnProps} from "./add-column";

type Props = {
    children?: any
} & AddColumnProps

export default class AddField extends AddColumn<Props> {

    render() {
        const classes = Classes('', this.props.className, {
            'show-popover': this.state.showPopover
        });

        return (
            <div className={classes} onClick={this.showPopover}>
                {this.props.children}
                {this.state.showPopover && this.renderPopover()}
            </div>
        );
    }
}